module.exports = __webpack_public_path__ + "img/arrBackHidde.430eebc5.svg";